import { ButtonCtaPrimary, InputText, Label, ModalActionBar, ModalContent, ModalHeader } from '@tbitop/ui';
import { CheckCircle } from 'phosphor-react';
import { useState } from 'react';
import type { NeukundenObjekt } from '../../../infrastructure/graphql/NeukundenObjektErstellenMutation';
import { useNeukundenObjektErstellenMutation } from '../../../infrastructure/graphql/NeukundenObjektErstellenMutation';

type Props = {
  onClose: () => void;
  onObjektCreated?: (objekt: NeukundenObjekt) => void;
};

export const ObjektAnlegen = ({ onClose, onObjektCreated }: Props) => {
  const [formValues, setFormValues, isValid] = useObjektErstellenFormState();
  const { execute: createObjekt, loading } = useNeukundenObjektErstellenMutation();


  async function onCreate() {
    if (!isValid) {
      return;
    }
    const result = await createObjekt({
      name: formValues.name || '',
      ort: formValues.ort || '',
      strasse: formValues.strasse || '',
      gedatId: formValues.nummer,
      postleitzahl: formValues.plz,
    });
    if (onObjektCreated && result.data) {
      onObjektCreated(result.data?.neukundenObjektErstellen);
    }
  }

  return (
    <>
      <ModalHeader title={'Neues Objekt'} onClose={onClose}/>
      <ModalContent className="flex flex-col gap-100">
        <>
          <Label label="Objektname*" labelPosition="top">
            <InputText required value={formValues.name} placeholder="Name" onValueChange={name => setFormValues({ ...formValues, name })}/>
          </Label>
          <Label label="Straße*" labelPosition="top">
            <InputText required value={formValues.strasse} placeholder="Straße" onValueChange={strasse => setFormValues({ ...formValues, strasse })}/>
          </Label>
          <Label label="Ort*" labelPosition="top">
            <InputText required value={formValues.ort} placeholder="Ort" onValueChange={ort => setFormValues({ ...formValues, ort })}/>
          </Label>
          <Label label="PLZ" labelPosition="top">
            <InputText required value={formValues.plz} placeholder="Postleitzahl" onValueChange={plz => setFormValues({ ...formValues, plz })}/>
          </Label>
          <Label label="GEDAT-ID" labelPosition="top">
            <InputText required value={formValues.nummer} placeholder="GEDAT-ID" onValueChange={nummer => setFormValues({ ...formValues, nummer })}/>
          </Label>
        </>
      </ModalContent>
      <ModalActionBar>
        <ButtonCtaPrimary icon={CheckCircle} onClick={onCreate} disabled={!isValid || loading}>Erstellen</ButtonCtaPrimary>
      </ModalActionBar>
    </>
  );
};

type ObjektErstellenForm = {
  name?: string;
  nummer?: string;
  ort?: string;
  plz?: string;
  strasse?: string;
};

const useObjektErstellenFormState = () => {
  const [values, setValues] = useState<ObjektErstellenForm>({
    name: undefined,
    nummer: undefined,
    plz: undefined,
    strasse: undefined,
    ort: undefined,
  });

  const isValid = !!values.name && !!values.ort && !!values.strasse;

  return [
    values,
    setValues,
    isValid,
  ] as const;
};
